import { render, staticRenderFns } from "./UserManual.vue?vue&type=template&id=0b0c80da&scoped=true"
import script from "./UserManual.vue?vue&type=script&lang=js"
export * from "./UserManual.vue?vue&type=script&lang=js"
import style0 from "./UserManual.vue?vue&type=style&index=0&id=0b0c80da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0c80da",
  null
  
)

export default component.exports